import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { pricingService } from '../../services/api/pricingService';

export function usePricingQuery(applicationId) {
  return useQuery({
    queryKey: ['pricing', applicationId],
    queryFn: () => pricingService.getByApplicationId(applicationId),
    enabled: !!applicationId,
  });
}

export function useUpdatePricingMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ applicationId, data }) => pricingService.update(applicationId, data),
    onSuccess: (_, { applicationId }) => {
      queryClient.invalidateQueries({ queryKey: ['pricing', applicationId] });
    },
  });
}
